import React from "react";

import { GridResult } from "2g-grid";

import useZakazniciGrid from "./useZakazniciGrid";

export function ZakazniciGrid() {
  const grid = useZakazniciGrid();
  return <GridResult {...grid} />;
}

ZakazniciGrid.propTypes = {};

export default React.memo(ZakazniciGrid);
